import * as THREE from 'three'
import Experience from '../Experience'

import vertexCircle from '../../../static/shaders/vertexCircle.glsl'
import fragmentCircle from '../../../static/shaders/fragmentCircle.glsl'
import vertexSquare from '../../../static/shaders/vertexSquare.glsl'
import fragmentSquare from '../../../static/shaders/fragmentSquare.glsl'

export default class Fox {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = experience.scene
    this.resources = experience.resources
    this.time = experience.time
    this.debug = experience.debug

    if (this.debug.active) {
    }
    // this.debugFolder = this.debug.ui.addFolder('fox')

    this.resource = this.resources.items.HellFest

    this.setMaterial()
    this.setModel()
  }
  setMaterial() {
    //Structure
    this.structureTexture = this.resources.items.structureTexture
    this.structureTexture.flipY = false
    this.structureTexture.encoding = THREE.sRGBEncoding
    this.structureMaterial = new THREE.MeshBasicMaterial({ map: this.structureTexture })

    //door
    this.doorTexture = this.resources.items.doorTexture
    this.doorTexture.flipY = false
    this.doorTexture.encoding = THREE.sRGBEncoding
    this.doorMaterial = new THREE.MeshBasicMaterial({ map: this.doorTexture })

    //detail
    this.detailTexture = this.resources.items.detailTexture
    this.detailTexture.flipY = false
    this.detailTexture.encoding = THREE.sRGBEncoding
    this.detailMaterial = new THREE.MeshBasicMaterial({ map: this.detailTexture })

    //statue
    this.statueTexture = this.resources.items.statueTexture
    this.statueTexture.flipY = false
    this.statueTexture.encoding = THREE.sRGBEncoding
    this.statueMaterial = new THREE.MeshBasicMaterial({ map: this.statueTexture, transparent: true })

    //painting
    this.paintingTexture = this.resources.items.paintingTexture
    this.paintingTexture.flipY = false
    this.paintingTexture.encoding = THREE.sRGBEncoding
    this.paintingMaterial = new THREE.MeshBasicMaterial({ map: this.paintingTexture })

    //Logo
    this.logoMaterial = new THREE.MeshBasicMaterial({ color: 0xff0000 })

    //icons
    this.iconSmallMaterial = new THREE.MeshBasicMaterial({ color: '#1a1a1a' })
    this.iconBigMaterial = new THREE.MeshBasicMaterial({ color: '#00d619' })

    //Portal
    this.portalMaterial = new THREE.MeshBasicMaterial({ color: '#0e9964' })
    this.portalMaterial.encoding = THREE.sRGBEncoding
    this.portalMaterial.toneMapped = false

    //shaderCircleMaterial
    this.shaderCircleMaterial = new THREE.ShaderMaterial({
      vertexShader: vertexCircle,
      fragmentShader: fragmentCircle,

      uniforms: {
        uTime: {
          value: 0,
        },
        uFirstColor: {
          value: new THREE.Color('#d64000'),
        },
        uSecondColor: {
          value: new THREE.Color('#59001c'),
        },
      },
    })

    //shaderSquareMaterial
    this.shaderSquareMaterial = new THREE.ShaderMaterial({
      vertexShader: vertexSquare,
      fragmentShader: fragmentSquare,

      uniforms: {
        uTime: {
          value: 0,
        },
        uFirstColor: {
          value: new THREE.Color('#5ad174'),
        },
        uSecondColor: {
          value: new THREE.Color('#0d004d'),
        },
      },
    })
  }

  setModel() {
    this.model = this.resource.scene
    this.model.position.y = -8
    this.scene.add(this.model)

    //Structure
    const structure = this.model.children.find(child => child.name === 'structure')
    structure.material = this.structureMaterial

    //Doors
    const doors = this.model.children.find(child => child.name === 'door')
    doors.material = this.doorMaterial

    //Detail
    const detail = this.model.children.find(child => child.name === 'detail')
    detail.material = this.detailMaterial

    //logo
    const logo = this.model.children.find(child => child.name === 'logo')
    logo.material = this.logoMaterial

    //icons
    const iconBig = this.model.children.find(child => child.name === 'iconBig2')
    iconBig.material = this.iconBigMaterial

    const icon = this.model.children.find(child => child.name === 'iconBig2001')
    icon.material = this.iconSmallMaterial

    const iconDoor = this.model.children.find(child => child.name === 'iconDoor')
    iconDoor.material = this.iconSmallMaterial

    //statue
    const statue = this.model.children.find(child => child.name === 'statue')
    statue.material = this.statueMaterial

    //painting
    const painting = this.model.children.find(child => child.name === 'painting')
    painting.material = this.paintingMaterial

    //circlesPortal
    const centerCircle = this.model.children.find(child => child.name === 'centerCircle')
    centerCircle.material = this.shaderSquareMaterial
    const middleCircle = this.model.children.find(child => child.name === 'middleCircle')
    middleCircle.material = this.shaderCircleMaterial
    const topCircle = this.model.children.find(child => child.name === 'topCircle')
    topCircle.material = this.shaderCircleMaterial

    //squarePortal
    const square = this.model.children.find(child => child.name === 'square')
    square.material = this.shaderSquareMaterial
    const square2 = this.model.children.find(child => child.name === 'square2')
    square2.material = this.shaderSquareMaterial
    const square3 = this.model.children.find(child => child.name === 'square3')
    square3.material = this.shaderSquareMaterial

    //window
    const window1 = this.model.children.find(child => child.name === 'window1')
    window1.material = this.shaderSquareMaterial
    const window2 = this.model.children.find(child => child.name === 'window2')
    window2.material = this.shaderSquareMaterial

    const triangle = this.model.children.find(child => child.name === 'triangle')
    triangle.material = this.shaderSquareMaterial
    const entrance = this.model.children.find(child => child.name === 'entrance')
    entrance.material = this.shaderCircleMaterial

    this.model.traverse(child => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true
      }
    })
  }

  update() {
    this.shaderCircleMaterial.uniforms.uTime.value = this.time.elapsed * 0.002
    this.shaderSquareMaterial.uniforms.uTime.value = this.time.elapsed * 0.002
  }
}
